import React, { useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PrimaryButton from "../general/PrimaryButton";
//import {ReactComponent as IncomeImage} from '../../resources/income.svg'
import InViewLoader from "./InViewLoader";
import IncomeImage from "./IncomeSVG";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontFamily: "SuperaGothic",
      textAlign: "left",
      margin: "80px 10%",
      [theme.breakpoints.down("sm")]: {
        display: "block",
        margin: "10%",
      },
      [theme.breakpoints.up("md")]: {
        display: "flex",
        marginRight: "5%",
        margin: "80px 10%",
        //marginTop:0
      },
    },
    text: {
      margin: "auto",
      [theme.breakpoints.down("sm")]: {
        //marginRight: '60px',
        marginBottom: "40px",
        marginRight: "auto",
        textAlign: "center",
        padding: "0",
        //marginRight: '20px',
        //marginLeft: '20px',
      },
      [theme.breakpoints.between("md", "lg")]: {
        //marginRight: '60px',
        //marginBottom: '60px',
        marginRight: "8%",
        textAlign: "center",
        //padding: "5%"
        //marginRight: '20px',
        //marginLeft: '20px',
      },
      [theme.breakpoints.up("xl")]: {
        marginRight: "5%",
        marginBottom: "auto",
        textAlign: "left",
        padding: "0",
      },
    },
    smallText: {
      textAlign: "left",
    },
    imageWrapper: {
      [theme.breakpoints.down("sm")]: {
        //display: 'block',
        margin: "auto",
        //width: '80%',
        maxWidth: "700px",
        //width: '80%',
      },
      [theme.breakpoints.up("md")]: {
        margin: "auto",
        flexShrink: 0,
        width: "50%",
        //height: '325px',
        //display: 'flex',
      },
    },
    spacing: {
      "@media (min-width:800px)": {
        marginTop: "25px",
        marginBottom: "15px",
      },
      "@media (max-width:800px)": {
        marginTop: "5vw",
        marginBottom: "0px",
      },
    },
  })
);

function AnonymizedSection() {
  const styles = useStyles();
  const [inView, setInView] = useState<boolean>(false);

  const markAsViewed = (value: boolean) => {
    if (!inView && value === true) {
      setInView(value);
    }
  };
  return (
    <div className={`${styles.root}`}>
      <div className={styles.text}>
        <Typography variant="h4" style={{ fontWeight: "bold" }}>
          How Does It Work?
        </Typography>
        <Typography
          variant="body1"
          style={{ textAlign: "left" }}
          className={`roboto-condensed ${styles.spacing}`}
        >
          At CollegeSharing, we pay you based on two factors: <br />
          <br />
          <span style={{ fontWeight: "bold" }}>
            1. The selectivity of the colleges you were admitted to
          </span>{" "}
          <br />
          <span style={{ fontWeight: "bold" }}>
            {" "}
            2. How many schools you got into
          </span>
        </Typography>
        <div style={{ margin: "auto", textAlign: "center", marginTop: "60px" }}>
          <PrimaryButton link="/faq" label="income_section.learn_more">
            <Typography variant="h5">Learn More</Typography>
          </PrimaryButton>
        </div>
      </div>
      <div className={styles.imageWrapper}>
        <InViewLoader setElementStatus={markAsViewed} />
        <IncomeImage shouldShow={inView} />
      </div>
    </div>
  );
}

export default AnonymizedSection;
